import React from "react";
import SingleColumnPage from "../../components/SingleColumnPage";
import Breadcrumb from "../../components/Breadcrumb";
import { Redirect, Route, Switch } from "react-router";
import AdminPortalPendingCustomers from "../AdminPortalPendingCustomers";
import SubNavigation from "../../components/SubNavigation";
import AdminPortalLogs from "../AdminPortalLogs";
import AdminPortalFunctions from "../AdminPortalFunctions";
import AdminPortalQueue from "../AdminPortalQueue";
import AdminPortalDevice from "../AdminPortalDevice";
import AdminPortalLoginAs from "../AdminPortalLoginAs";
import AdminPortalTmaReport from "../AdminPortalTmaReport";
import AdminPortalLicenses from "../AdminPortalLicenses";
import AdminPortalPreShipment from "../AdminPortalPreShipment";
import AdminPortalBattery from "../AdminPortalBattery";

export default function AdminPortal({ history }) {
  const breadcrumbs = () => <Breadcrumb title="Admin portal" />;
  const subNav = [
    { to: `/admin_portal/pre_shipment`, name: "Pre-shipment" },
    { to: `/admin_portal/battery`, name: "Battery" },
    { to: `/admin_portal/login_as`, name: "Login as" },
    { to: `/admin_portal/pending`, name: "Pending customers" },
    { to: `/admin_portal/device`, name: "Device lookup" },
    { to: `/admin_portal/tma_report`, name: "TMA Report" },
    { to: `/admin_portal/licenses`, name: "Extend licenses" },
    //  { to: `/admin_portal/logs`, name: 'Logs' },
    { to: `/admin_portal/functions`, name: "Functions" },
    // { to: `/admin_portal/queue`, name: 'Queue' },
  ];
  return (
    <SingleColumnPage breadcrumbs={breadcrumbs}>
      <SubNavigation items={subNav} history={history} />
      <Switch>
        <Redirect from="/admin_portal" to="/admin_portal/login_as" exact />
        <Route
          path="/admin_portal/pre_shipment"
          component={AdminPortalPreShipment}
        />
        <Route path="/admin_portal/battery" component={AdminPortalBattery} />
        <Route
          path="/admin_portal/login_as"
          component={AdminPortalLoginAs}
        />
        <Route
          path="/admin_portal/pending"
          component={AdminPortalPendingCustomers}
        />
        <Route path="/admin_portal/device" component={AdminPortalDevice} />
        <Route path="/admin_portal/tma_report" component={AdminPortalTmaReport} />
        <Route path="/admin_portal/licenses" component={AdminPortalLicenses} />
        <Route path="/admin_portal/logs" component={AdminPortalLogs} />
        <Route
          path="/admin_portal/functions"
          component={AdminPortalFunctions}
        />
        <Route path="/admin_portal/queue" component={AdminPortalQueue} />
      </Switch>
    </SingleColumnPage>
  );
}
